/** Money is whole UZS everywhere (ADR-006). Never floats, never tiyin. */
import { currencySuffix } from './locale'

/** Non-breaking space: "68 000 сум" must never wrap (docs/frontend/README.md). */
export const NBSP = ' '

/** Русская подпись валюты; текущая — `currencySuffix()`. */
export const CURRENCY_SUFFIX = 'сум'

/** 1234567 → "1 234 567" (groups joined with NBSP). */
export function formatAmount(amount: number): string {
  const rounded = Math.round(amount)
  const sign = rounded < 0 ? '-' : ''
  const digits = Math.abs(rounded).toString()
  const groups: string[] = []
  for (let end = digits.length; end > 0; end -= 3) {
    groups.unshift(digits.slice(Math.max(0, end - 3), end))
  }
  return sign + groups.join(NBSP)
}

/** 68000 → "68 000 сум" · "68 000 so‘m" — по языку отображения. */
export function formatMoney(amount: number, suffix: string = currencySuffix()): string {
  return `${formatAmount(amount)}${NBSP}${suffix}`
}
